export enum PersistKey {
    test = '_TS:TEST',
    url = '_TS:APP_URL',
    token = '_TS:TOKEN',
    session = '_TS:SESSION',
    partner = '_TS:PARTNER',
    betslip = '_TS:BETSLIP',
    featureToggle = '_TS:FEATURE_TOGGLE',
}
